import React, { useEffect, useState } from "react";
import "admin-lte/dist/css/adminlte.min.css";
import { Link } from "react-router-dom";
import axios from "axios";
import Sidebar2 from "./Sidebar2"; // Import Sidebar2

const base_url = process.env.REACT_APP_API_URL;

const AdminHeader = ({ toggleSidebar, isSidebarOpen, isMobile }) => {
  const [data, setData] = useState();
  const [isSidebar2Open, setIsSidebar2Open] = useState(false); // State for Sidebar2

  const auth = localStorage.getItem("admin");

  const fetchBalance = async () => {
    try {
      const response = await axios.post(
        base_url + "/api/webapi/admin/listMember",
        {
          typeid: "1",
          pageno: 1,
          limit: 10,
          search: "",
          language: "vi",
        },
        {
          withCredentials: true,
          headers: {
            "content-type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );

      // console.log('rpee head',response);
      if (response?.status) {
        const bal = response?.data.datas;
        // console.log('ball',bal);
        bal?.map((ball) => {
          if (ball?.token === auth) {
            setData(ball?.money);
          }
        });
      }
    } catch (error) {
      console.error("Error fetching balance:", error);
    }
  };

  useEffect(() => {
    fetchBalance();
  }, []);

  return (
    <div className="wrapper">
      {/* Navbar */}
      <nav
        className={`main-header navbar navbar-expand navbar-dark admin_header ${
          isSidebarOpen ? "" : "open-content-wrapper"
        }`}
      >
        {/* Left navbar links */}
        <ul className="navbar-nav">
          <li className="nav-item hamburger">
            <Link
              className="nav-link"
              onClick={(e) => {
                e.preventDefault();
                toggleSidebar(); // ensure toggleSidebar works in both mobile and desktop
              }}
              href="#"
              role="button"
            >
              <i className="fas fa-bars fs-5"></i>
            </Link>
          </li>
        </ul>

          {/* mobile view navbar */}
          
          {isMobile && (
          <div className="mobile-toggle-container ml-2">
            {!isSidebarOpen && (
              <Link
                data-target="nav-mobile"
                className="sidenav-trigger"
                onClick={toggleSidebar}
              >
                <img
                  src="/assets/images/hamburger.svg"
                  alt="Open Menu"
                  className="hamburger-icon"
                  style={{ width: "24px", height: "24px" }}
                />
              </Link>
            ) 
          }
        </div>
          )}
          

        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <div className="balance">
              Balance : <span className="amount">{data || 0}</span>
            </div>
          </li>
        </ul>

        {/* Right navbar links */}
        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <Link
              className="nav-link"
              data-widget="fullscreen"
              href="#"
              role="button"
            >
              <i className="fas fa-expand-arrows-alt"></i>
            </Link>
          </li>

          {/* Profile Image to Toggle Sidebar2 */}
          <li className="nav-item m-2" onClick={() => setIsSidebar2Open(!isSidebar2Open)} style={{ cursor: "pointer" }}>
            <img
              src="https://tse3.mm.bing.net/th?id=OIP.c2mM1ZkzOlxhYtugBEUU5QHaHa&pid=Api&P=0&h=180"
              alt="Profile"
              style={{ height: "30px", width: "30px", borderRadius: "50%" }}
            />
          </li>
        </ul>
      </nav>

      {/* Sidebar2 */}
      <Sidebar2 isOpen={isSidebar2Open} toggleSidebar={() => setIsSidebar2Open(!isSidebar2Open)} />
    </div>
  );
};

export default AdminHeader;